import { datadogRum, type User } from '@datadog/browser-rum'

export default defineNuxtPlugin(() => {
  const { public: config } = useRuntimeConfig()

  // Datadog RUM is client-only and requires both env vars to be configured.
  // If either is missing (e.g. local dev), skip init and fall through to the no-op provider.
  if (!import.meta.server && config.datadogApplicationId && config.datadogClientToken) {
    datadogRum.init({
      applicationId: config.datadogApplicationId as string,
      clientToken: config.datadogClientToken as string,
      site: 'us5.datadoghq.com',
      service: 'portal',
      env: config.vercelENV,
      // If vercelGitCommitSHA is an empty string (local/preview), set to undefined
      // to avoid sending a blank version tag to Datadog.
      version: config.vercelGitCommitSHA || undefined,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    })

    return {
      provide: {
        datadog: {
          // Associates the current RUM session with a specific user.
          // Called once on first authentication in store/self.js.
          setUser: (user: User & { id: string }) => {
            datadogRum.setUser(user)
          },
        },
      },
    }
  }

  // Always provide $datadog so callers don't need to guard against it being undefined
  // in environments where Datadog is not configured.
  return {
    provide: {
      datadog: {
        setUser: () => {},
      },
    },
  }
})
